<template>
  <h1 v-if="!isChangingCampaign" class="tw:text-gray-800 tw:font-bold tw:text-center tw:mb-8 tw:text-2xl">
    {{ $t('rc_setup_campagn_header') }}
  </h1>
  <p v-if="isChangingCampaign" class="tw:mb-8 tw:text-center tw:md:text-left">
    {{ $t('rc_campaign_type_options_text') }}
  </p>

  <div class="scrollable-container tw:flex tw:sm:hidden tw:mb-[40px]">
    <div class="scrollable-content" id="cpa-item" v-if="eligibleTypeOfCPACampaign !== null">
      <CampaignTypeSelectCardNew
        :campaignType="eligibleTypeOfCPACampaign"
        class="tw:mx-auto"
        isRecommended
        :isSelected="selectedCampaignType === eligibleTypeOfCPACampaign"
        :isCurrentlyActive="currentlyActiveCampaignType === eligibleTypeOfCPACampaign"
      />
    </div>
  </div>

  <div class="tw:hidden tw:sm:grid tw:sm:gap-4 tw:sm:justify-center tw:sm:grid-flow-col">
    <button @click="onCampaignTypeCardClick(eligibleTypeOfCPACampaign)" v-if="eligibleTypeOfCPACampaign !== null">
      <CampaignTypeSelectCardNew
        :campaignType="eligibleTypeOfCPACampaign"
        :isSelected="
          selectedCampaignType === eligibleTypeOfCPACampaign || eligibleTypeOfCPACampaign.toLowerCase() === 'netcpa'
        "
        :isCurrentlyActive="currentlyActiveCampaignType === eligibleTypeOfCPACampaign"
      />
    </button>
  </div>
  <p class="tw:text-center tw:text-gray-700 tw:mt-8 tw:mb-0">{{ $t('rc_campaign_footnote') }}</p>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

import CampaignTypeSelectCardNew from '@/components/rateConnect/CampaignTypeSelectCardNew.vue'

const props = defineProps({
  currentlyActiveCampaignType: {
    type: String,
    required: false,
    default: null,
    validator(value) {
      return ['netcpa', 'cpa', 'cpc'].includes(value)
    },
  },
  eligibleTypeOfCPACampaign: {
    type: String,
    default: 'netcpa',
    validator(value) {
      return ['netcpa', 'cpa', null].includes(value)
    },
  },
  selectedCampaignType: {
    type: String,
    default: 'netcpa',
    validator(value) {
      return ['netcpa', 'cpa', 'cpc'].includes(value)
    },
  },
  isChangingCampaign: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['onSelectedCampaignTypeChange'])
const observer = ref(null)
const cpcElementMobile = ref(null)

const onCampaignTypeCardClick = type => {
  emit('onSelectedCampaignTypeChange', type)
}

const setIntersectionObserverForMobile = () => {
  const carouselContainer = window.document.querySelector('.scrollable-container')
  const cards = window.document.querySelectorAll('.scrollable-content')
  const IntersectionObserverOptions = { threshold: 0.5, root: carouselContainer }
  observer.value = new IntersectionObserver(function (entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const campaignType = entry.target.id === 'cpc-item' ? 'cpc' : props.eligibleTypeOfCPACampaign
        emit('onSelectedCampaignTypeChange', campaignType)
      }
    })
  }, IntersectionObserverOptions)
  cards.forEach(card => observer.value.observe(card))
}

onMounted(() => {
  if (window.innerWidth < 500) {
    if (props.selectedCampaignType === 'cpc')
      cpcElementMobile.value.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'instant' })
    setIntersectionObserverForMobile()
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    })
  }
})

onUnmounted(() => {
  observer.value?.disconnect()
})
</script>
